import PropTypes from 'prop-types';
import { Button } from '@mui/material';

const styles = {
  button: { borderRadius: '100px' },
};

const RoundedButton = ({ children, ...props }) => (
  <Button {...props} fullWidth sx={styles.button}>
    {children}
  </Button>
);

RoundedButton.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RoundedButton;
